module.exports = __webpack_public_path__ + "img/bankId.75332b5b.svg";